<!-- eslint-disable vue/multi-word-component-names -->
<script>
import AppTitleHeader from '../../components/app/TitleHeader.vue';
import AppConversation from '../../components/app/conversation.vue';
import ChiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';
export default {
  inject: [''],
  components: { AppTitleHeader, AppConversation },
  mixins: [ChiefComplaintMixin],
  props: {
    patientDoctorOrders: {
      type: Array,
      default: () => [],
    },
    patientDoctorActions: {
      type: Array,
      default: () => [],
    },
    selectedChiefComplaint: {
      type: String,
      default: '',
    },
    noteText: {
      type: String,
      default: '',
    },
    selectedResult: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chiefComplaintSearch: '',
      currentActionTab: 0,

      resultTabs: [
        {
          id: 0,
          text: 'سایر',
          className: 'normal-letter-spacing',
          color: (id) => (this.isActive(id) ? 'darkColor' : 'lightColor'),
          onClick: (id) => this.setResultTabActive(id),
        },
        {
          id: 1,
          text: 'انتقال',
          className: 'normal-letter-spacing',
          color: (id) => (this.isActive(id) ? 'darkColor' : 'lightColor'),
          onClick: (id) => this.setResultTabActive(id),
        },
        {
          id: 2,
          text: 'عدم انتقال',
          className: 'normal-letter-spacing',
          color: (id) => (this.isActive(id) ? 'darkColor' : 'lightColor'),
          onClick: (id) => this.setResultTabActive(id),
        },
      ],
      resultTabItems: [
        [
          {
            label: 'قطع حین مکالمه',
            value: 'قطع حین مکالمه',
          },
          { label: 'توصیه به مراجعه', value: 'توصیه به مراجعه' },
          { label: 'نامشخص', value: 'نامشخص' },
        ],
        [
          { label: '10-33', value: '10-33' },
          { label: '10-99', value: '10-99' },
          { label: '10-96', value: '10-96' },
        ],
        [
          { label: '10-35', value: '10-35' },
          { label: '10-19', value: '10-19' },
          { label: '10-29', value: '10-29' },
        ],
      ],
      resultBtns: [
        {
          text: 'ذخیره و بستن',
          outlined: false,
          isText: false,
          onClick: (id) => this.onResultBtnClick(id),
        },
        {
          text: 'ذخیره',
          outlined: true,
          isText: false,
          onClick: (id) => this.onResultBtnClick(id),
        },
        {
          text: 'انصراف',
          outlined: false,
          isText: true,
          onClick: (id) => this.onResultBtnClick(id),
        },
      ],
    };
  },
  mounted() {
    this.getListOfChiefComplaintsForOther();
  },
  methods: {
    onChangeChiefComplaint: function (item) {
      this.$emit('updateChiefComplaint', item?.title);
    },
    onChangeNote: function (text) {
      this.$emit('updateNoteText', text);
    },
    setResultTabActive: function (id) {
      this.currentActionTab = id;
    },
    isActive: function (id) {
      return this.currentActionTab === id;
    },
    updateResult: function (item) {
      this.$emit('updateSelectedResult', item);
    },
    saveResultAndCloseModal: function () {
      this.$emit('saveResult', () => this.$emit('closeModal'));
    },
    onResultBtnClick: function (index) {
      switch (index) {
        case 0:
          this.saveResultAndCloseModal();
          break;
        case 1:
          this.$emit('saveResult');
          break;
        case 2:
          this.$emit('closeModal');

          break;
        default:
          break;
      }
    },
  },
  watch: {
    selectedResult: function (currentVal) {
      const isInSecondTab = [...this.resultTabItems][1]?.some(
        ({ value }) => currentVal === value,
      );
      const isInThirdTab = [...this.resultTabItems][2]?.some(({ value }) => value === currentVal);
      if (isInSecondTab) this.currentActionTab = 1;
      else if (isInThirdTab) this.currentActionTab = 2;
      else return;
    },
  },
};
</script>
<template>
  <v-row no-gutters>
    <v-col cols="12" class="box pa-2">
      <v-row no-gutters>
        <v-col cols="9" class="pl-2">
          <app-title-header title="اقدامات دارویی" />
        </v-col>
        <v-col cols="3" class="flex justify-end">
          <v-btn @click="$emit('showDrugModal')" small dense text color="darkColor">
            <v-icon>mdi-plus mdi-18px</v-icon>
            افزودن
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4">
        <v-expansion-panels flat class="flex gap-2">
          <v-expansion-panel v-for="{
            drugtitle,
            drugGroupTitle,
            id,
            standByTitle,
            drugCount,
            orderTypeTitle,
          } in patientDoctorOrders" :key="id" class="patient-doctor-collaps">
            <v-expansion-panel-header>
              <div class="flex-gap-1">
                <v-icon @click.stop.prevent="$emit('removeItemFromDrugs', id)" dark color="darkColor">
                  mdi-close-circle mdi-18px
                </v-icon>
                <div class="flex-gap-1">
                  <div>
                    {{ drugtitle }}
                  </div>
                  <div>({{ drugGroupTitle }})</div>
                </div>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row no-gutters>
                <v-col>
                  <app-conversation question="دستور استفاده" :answer="standByTitle" />
                </v-col>
                <v-col>
                  <app-conversation class="px-2 text-center" question="تعداد" :answer="drugCount" />
                </v-col>
                <v-col>
                  <app-conversation question="نحوه مصرف" :answer="orderTypeTitle" />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-col>
    <v-col cols="12" class="box pa-2 my-2">
      <v-row no-gutters>
        <v-col cols="9" class="pl-2">
          <app-title-header title="اقدامات درمانی" />
        </v-col>
        <v-col cols="3" class="flex justify-end">
          <v-btn text small dense color="darkColor" @click.stop="$emit('showGeneralActionModal')">
            <v-icon>mdi-plus mdi-18px</v-icon>
            افزودن
          </v-btn>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4">
        <v-chip-group column>
          <v-chip v-for="(text, index) in patientDoctorActions" :key="index" close close-icon="mdi-close-circle"
            @click:close="$emit('removeItemFromGeneralAction', text)" class="all-chip">
            {{ text }}
          </v-chip>
        </v-chip-group>
      </v-row>
    </v-col>
    <v-col cols="12" class="box pa-2">
      <v-row no-gutters>
        <v-col cols="12">
          <app-title-header title="تشخیص و توضیحات" />
        </v-col>
        <v-col class="mt-2">
          <v-row no-gutters>
            <v-col cols="12">
              <v-combobox hide-details :value="selectedChiefComplaint" label="تشخیص" dense outlined
                :search-input.sync="chiefComplaintSearch" :items="allChiefComplaintsForOther" item-text="title"
                item-value="title" clearable clear-icon="mdi-close-circle-outline"
                prepend-inner-icon="mdi-file-document mdi-18px" @change="onChangeChiefComplaint"></v-combobox>
            </v-col>
            <v-col cols="12" class="mt-2">
              <v-textarea hide-details rows="2" dense label="توضیحات" :value="noteText" outlined
                @input="onChangeNote" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="box pa-2 mt-2">
      <v-row no-gutters>
        <v-col cols="12">
          <app-title-header title="نتیجه مشاوره" />
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="12" class="mb-2">
          <v-row no-gutters class="result-tab-container gap-2">
            <v-btn v-for="{ className, color, id, onClick, text } in resultTabs" :key="id" dark :color="color(id)"
              @click="onClick(id)" :class="`${className} result-tab rounded-lg rounded-b-0`">
              {{ text }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12">
          <v-radio-group :value="selectedResult" dense @change="updateResult" class="flex-gap-2">
            <v-row no-gutters class="gap-1 items-center result-items-cotainer">
              <v-radio hide-details v-for="{ label, value } in resultTabItems[currentActionTab]" :key="value"
                :label="label" :value="value" class="result-item"></v-radio>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2 gap-4 justify-center">
        <v-btn v-for="({ isText, outlined, text, onClick }, index) in resultBtns" :key="index" rounded :text="isText"
          :outlined="outlined" color="darkColor" dark @click.stop="onClick(index)" class="normal-letter-spacing">
          {{ text }}
        </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>
<style lang="scss">
.patient-doctor-collaps {
  background-color: var(--background-color) !important;
  border-radius: 6px;
  padding: 0.5rem !important;
}
</style>
<style lang="scss" scoped>
.box {
  background-color: white;
  min-height: 100px;
  max-height: 200px;
  overflow-y: auto;

  &:nth-child(3) {
    min-height: max-content;
  }

  .result-tab-container {
    .result-tab {
      flex: 1 1 auto;
    }
  }

  .result-items-cotainer {
    .result-item {
      flex: 1 1 auto;
      margin: 0 !important;
    }
  }
}
</style>
